import EnvironmentTypes = Infospeed.FrontEnd.COT.EnvironmentTypes;

import { BrowserModule, DomSanitizer, Title } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatIconRegistry } from '@angular/material';
import { SharedMaterialAndFlexModule } from '../../components/shared-material-flex.module';
import { appRouting } from './app-islington.router';
import { CotHttpModule } from '../../http-communication/cot-http.module';
import { WidgetsModule } from '../../widgets/widgets.module';
import { AppIslingtonComponent } from './app-islington.component';
import { IslingtonFooterModule } from './footer/islington-footer.module';
import { IslingtonFooterService } from './footer/islington-footer.service';
import { FileUploaderComponent } from '../../widgets/file-uploader/file-uploader.component';
import { StickySnackbarComponent } from '../../widgets/sticky-snackbar/sticky-snackbar.component';
import { PageNotFoundModule } from '../../components/page-not-found/page-not-found.module';
import { LoadingSpinnerComponent } from '../../widgets/loading-spinner/loading-spinner.component';
import { CommonNotificationService } from '../../services/common-notification.service';
import { CommonUtilityService, CustomerClassifier, DeviceClassifier, CustomerName } from '../../services/common-utility.service';
import { environment } from '../../../environments/environment';
import { CotHttp } from '../../http-communication/cot-http.service';
import { IslingtonHeaderModule } from './header/islington-header.module';

@NgModule({
    declarations: [
        AppIslingtonComponent
    ],
    imports: [
        BrowserModule,
        IslingtonFooterModule,
        IslingtonHeaderModule,
        appRouting,
        WidgetsModule,
        BrowserAnimationsModule,
        CotHttpModule,
        SharedMaterialAndFlexModule,
        PageNotFoundModule
    ],
    exports: [],
    providers: [Title, IslingtonFooterService, CommonNotificationService, CommonUtilityService, CustomerClassifier, DeviceClassifier,
        { provide: APP_INITIALIZER, useFactory: initAppFactory, deps: [CotHttp], multi: true }],
    bootstrap: [AppIslingtonComponent]
})

export class AppIslingtonModule {
    constructor() {
    }
}

export function initAppFactory(cotHttp: CotHttp) {
    //return () => new Promise((resolve, reject) => resolve());
    if (environment.dev) {
        return () => cotHttp.setEnvironment(EnvironmentTypes.dev, CustomerName.ISLINGTON);
    }
    else if (environment.uat) {
        return () => cotHttp.setEnvironment(EnvironmentTypes.uat, CustomerName.ISLINGTON);
    }
    else if (environment.prod) {
        return () => cotHttp.setEnvironment(EnvironmentTypes.prod, CustomerName.ISLINGTON);
    }
}



// WEBPACK FOOTER //
// ./src/app/customizations/islington/app-islington.module.ts